import { SidebarTrigger } from "@/shared/ui/sidebar"

/**
 * Header toggle button component using shadcn SidebarTrigger
 * Toggles sidebar visibility when clicked
 */
export function HeaderToggle() {
	return <SidebarTrigger />
}
